import { render, staticRenderFns } from "./chartsPie.vue?vue&type=template&id=20044f64&scoped=true&"
import script from "./chartsPie.vue?vue&type=script&lang=js&"
export * from "./chartsPie.vue?vue&type=script&lang=js&"
import style0 from "./chartsPie.vue?vue&type=style&index=0&id=20044f64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20044f64",
  null
  
)

export default component.exports